import { Button } from '@mui/material'
import React from 'react'

const SaveButton = ({ label, onClick, disabled }) => {
    return (
        <Button
            variant="contained"
            sx={{
                width: '90px',
                height: '35px',
                borderRadius: '5px',
                border: '1px',
                background: '#5C3685',
                textTransform: 'capitalize',
                fontFamily: 'Times New Roman',
                fontWeight: '400',
                fontSize: '18px',
                lineHeight: '20.7px'
            }}
            onClick={onClick}
            disabled={disabled}
        >
            {label}
        </Button>
    )
}

export default SaveButton